module.exports = __webpack_public_path__ + "static/media/GothamRnd-Light.299e47eb.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Light.eot
 ** module id = 1350
 ** module chunks = 0
 **/